import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

import { UICarbonNumberField } from '@futrli/ui-components';

import headerStyles from '../../prediction-header-bar/prediction-header-bar.scss';
import styles from '../repeating-method.scss';

interface AmountProps {
  currencySymbol: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  value: string;
}

export const Amount = ({ currencySymbol, disabled, onChange, value }: AmountProps) => {
  const intl = useIntl();

  return (
    <UICarbonNumberField
      autoComplete="off"
      className={clsx(headerStyles.formInput, styles.spaceBottom)}
      disabled={disabled}
      onChange={onChange}
      value={value}
      label={intl.formatMessage({ id: 'common.amount', defaultMessage: 'Amount' })}
      type="currency"
      currencySymbol={currencySymbol}
      size="large"
    />
  );
};
